<template>
    <header-layout />
    <content-layout />
    <footer-layout />
</template>

<script>
    import HeaderLayout from "./parts/HeaderLayout";
    import ContentLayout from "./parts/ContentLayout";
    import FooterLayout from "./parts/FooterLayout";

    export default {
        name: 'CommonLayout',
        components: { HeaderLayout, FooterLayout, ContentLayout }
    }
</script>
